@if (loading()) {
  <app-ui-skeleton-grid [rows]="3" [rowHeight]="56" />
} @else if (error()) {
  <app-ui-empty-state icon="heroDocumentText" title="Erro ao carregar" [description]="error()!">
    <button appButton variant="secondary" actions (click)="load()">Tentar novamente</button>
  </app-ui-empty-state>
} @else if (rows().length) {
  <app-ui-record-list>
    @for (r of rows(); track r.id) {
      <div appUiRecordRow [interactive]="false" class="!block !min-h-0 !p-0">
        <button
          appUiBackdropButton
          type="button"
          class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition hover:bg-soft"
          (click)="toggle(r.id)"
        >
          <div class="flex items-center gap-2">
            <span appBadge [tone]="r.statusTone">{{ r.statusLabel }}</span>
            <span class="text-sm text-ink">{{ r.periodLabel }}</span>
          </div>
          <span class="text-sm font-medium text-ink">{{ r.totalLabel }}</span>
        </button>

        @if (expandedId() === r.id) {
          <div class="grid gap-2 border-t border-line bg-soft px-4 py-3">
            @if (loadingItems() && !expandedItems()) {
              <app-ui-skeleton-grid [rows]="2" [rowHeight]="28" />
            } @else if (expandedItems(); as items) {
              @for (it of items; track it.id) {
                <div class="flex items-center justify-between gap-3 text-sm">
                  <span class="text-muted">{{ it.description }}</span>
                  <span class="text-ink">{{ it.amountLabel }}</span>
                </div>
              }
            }
            @if (r.receiptUrl) {
              <a
                appButton
                variant="secondary"
                size="sm"
                [href]="r.receiptUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="justify-self-start"
              >
                <ng-icon name="heroArrowTopRightOnSquare" size="16" aria-hidden="true" />
                Ver recibo
              </a>
            }
          </div>
        }
      </div>
    }
  </app-ui-record-list>
} @else {
  <app-ui-empty-state
    icon="heroDocumentText"
    title="Nenhuma fatura"
    description="As faturas da mensalidade do plano aparecerão aqui quando forem geradas."
  />
}
